import React from "react";
import { Spin } from "antd";
import { getHpcLogStatus } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";

const updateMap = new Map([
  ["", ""],
  ["loading", "命令下发中"],
  ["error", "下载失败"],
  ["success", "下载成功"],
]);

class DownHPCLogProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: 0,
      fileN:null,
      spinningL:false,
      downLogStatus: this.props.downLogStatus || "",
    };
    this.interval = null;
  }

  componentDidMount() {
    if (!this.props.downLogStatus) {
      this.getProgress();

      this.interval = setInterval(() => {
        this.getProgress();
      }, 2000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // 获取进度
  getProgress = () => {
    this.setState({
      spinningL:true
    });
    fetchHandler(getHpcLogStatus, {
      stubId: this.props.logId,
    }).then((res) => {
      console.info('今儿个： ' + res.code)
      if (res && res.code === "success") {
        let status = "";
        //1：下载中，2：成功，3：下载失败，4：被其他任务顶替
        if (res.data.code == 3 ) {
          status = "下载失败";

          clearInterval(this.interval);
            setTimeout(() => {
              this.setState({
                downLogStatus: status,
                spinningL:false
              });
            }, 1000);
        } else if (res.data.code == 4 ) {
          status = "被其他任务顶替";

          clearInterval(this.interval);
            setTimeout(() => {
              this.setState({
                downLogStatus: status,
                spinningL:false
              });
            }, 1000);
        } else if (res.data.code == 1 ) {
          status = "下载中";
          this.setState({
            downLogStatus: status
          });
        } else if (res.data.code == 2 ) {
          status = "下载成功";
          clearInterval(this.interval);
            setTimeout(() => {
              status = "success";
              this.setState({
                fileN:res.data.filePath,
                downLogStatus: status,
                spinningL:false
              });
            }, 1000);
        } else {
          clearInterval(this.interval);
            setTimeout(() => {
              status = "下载失败";
              this.setState({
                fileN:res.data.filePath,
                downLogStatus: status,
                spinningL:false
              });
            }, 1000);
        }

        
      } else {
        this.setState({
          spinningL:false
        });
      }
    });
  };

  render() {
    const { downLogStatus } = this.state;
    return (
      <div>
        {this.state.fileN == null ? (
          <h4 style={{ textAlign: "center" }}>{(downLogStatus)}</h4>
        ) : (
          <a target="_blank" style={{ textAlign: "center", display:"block", fontSize:"18px" }} href={this.state.fileN}>获取文件</a>
        )}
        
        <Spin spinning={this.state.spinningL}></Spin>
      </div>
    );
  }
}

export default DownHPCLogProgress;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/downHPCLogProgress.js